import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { BoardStatus, boardState, setStatus } from 'common/modules/app/board';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { Master } from 'common/modules/app/master';
import {
  UserInformation,
  updateUser,
  UpdateKeyValue,
  getLogin
} from 'common/modules/domain/user';
import { WelcomeBoard } from 'pages/board/components/WelcomeBoard';
import { AppState } from 'pages';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const masterState = useSelector<AppState, Master>(
    (state) => state.app.master
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );
  return {
    board: boardState,
    master: masterState,
    user: userState,
    glossary: Glossary.instance(glState)
  };
};

type SelectedState = ReturnType<typeof useStateProps>;
/**
 * StoreのStateとActionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const _board = state.board;
  const _master = state.master;
  const _user = state.user;
  /** WelcomeBoardの表示有無 */
  const _isDisplay = _board.status === BoardStatus.FIRST_DISP;

  /** 言語選択クリック時の処理 */
  const onClickLanguage = () => {
    dispatch(setStatus(BoardStatus.LANGUAGE_FROM_FIRST_DISP));
  };

  /** 国地域選択クリック時の処理 */
  const onClickCountry = () => {
    // 国マスターファイルから選択されている国がどの地域に所属するか確認
    let region = '';
    for (const [key, value] of Object.entries(_master.country)) {
      // 地域に所属する国リストに存在するか確認
      for (const country of value.countries) {
        if (country.code === _user.country) {
          region = key;
          break;
        }
      }
      // 所属する地域が確定したらループを抜ける
      if (region) {
        dispatch(updateUser(UpdateKeyValue.KEY_REGION, region));
        break;
      }
    }
    dispatch(setStatus(BoardStatus.COUNTRY_DISP));
  };

  /** CanonIDログインクリック時の処理 */
  const onClickCanonIDLogin = () => {
    dispatch(setStatus(BoardStatus.NOT_DISP));
    dispatch(getLogin());
  };

  /** 現在選択している言語のグロッサリIDを取得 */
  let selectLangGlId = '';
  if (_master.language[_user.language]) {
    selectLangGlId = _master.language[_user.language].glossary;
  }

  return {
    isDisplay: _isDisplay,
    glossary: state.glossary,
    selectLangGlId: selectLangGlId,
    onClickLanguage: onClickLanguage,
    onClickCountry: onClickCountry,
    onClickCanonIDLogin: onClickCanonIDLogin
  };
};

/**
 * 初回アクセス画面全体のContainer Component
 */
export default function ContainerComponent() {
  const _props = { ...useMargeProps(useStateProps()) };
  return <WelcomeBoard {..._props} />;
}
